var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoppePageDefaultImageSquareInner = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 375",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375 0H0v375h375V0zM147.825 165.091c-10.255 0-18.574-8.31-18.574-18.546 0-10.235 8.319-18.545 18.574-18.545 10.247 0 18.558 8.31 18.558 18.545 0 10.236-8.311 18.546-18.558 18.546zM310.642 247H341l-94.611-102.065c-2.759-1.826-7.23-1.826-9.989 0l-85.999 56.98c-2.751 1.827-7.222 1.827-9.981 0l-20.003-13.257c-2.751-1.826-7.222-1.826-9.981 0L34 247h276.642z"
  })));
});
export default SvgDoppePageDefaultImageSquareInner;